<template>
    <v-alert dense color="info" class="col-12 py-4 pb-3 text-center white--text mb-0 alert-gradient">
        <div class="d-inline-block mr-3">
            <v-btn outlined color="white" class="mt-0 rounded-lg px-5"
            @click="returnPanel()"
            small
            >
                <v-icon color="white " size="18px">
                    mdi-keyboard-return
                </v-icon>
            </v-btn>
            <p class="button-text text-center mt-1 mb-0">Regresar</p>
        </div>

        <div class="d-inline-block mr-3">
            <v-btn @click="showModal = true" outlined color="white" class="mt-0 rounded-lg px-5" small>
                <v-icon color="white " size="18px">
                    mdi-collage
                </v-icon>
            </v-btn>
            <p class="button-text text-center mt-1 mb-0">Plantilla</p>
        </div>

        <div class="d-inline-block mr-3">
            <v-btn outlined color="white" class="mt-0 rounded-lg px-5"
            @click="goHarmony('/' + harmony.slug)"
            small
            >
                <v-icon color="white" size="18px">
                    mdi-web
                </v-icon>
            </v-btn>
            <p class="button-text text-center mt-1 mb-0">Ver Harmony</p>
        </div>

        <div class="d-inline-block">
            <v-btn outlined color="white" class="mt-0 rounded-lg px-5"
            v-clipboard:copy="'https://harmony.fan/' + harmony.slug"
            v-clipboard:success="onCopy"
            small
            >
                <v-icon color="white " size="18px">
                    mdi-content-copy
                </v-icon>
            </v-btn>
            <p class="button-text text-center mt-1 mb-0">Copiar enlace</p>
        </div>
        <ModalLayouts
        :currentLayout="harmony.site_settings.layout.name"
        :harmony="harmony"
        @confirm="$emit('layout-change', $event)"
        v-model="showModal"
        />
    </v-alert>
</template>

<script>
import ModalLayouts from '@/components/partials/harmony/Editor/ModalLayouts.vue';
export default {
    components: { ModalLayouts },
    name: "EditorNavbar",

    props: {
        harmony: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showModal: false
        };
    },
    methods: {
        returnPanel() {
            this.$router.push('/panel');
            window.reload();
        },

        goHarmony(value) {
            window.open(value, '_blank');
        },

        onCopy() {
            this.$vs.notify({
                title: this.$t('panelHome.onCopy-title'),
                text: this.$t('panelHome.onCopy-text'),
                color: 'rgb(95 189 233)',
                icon: 'content_copy',
                position: 'bottom-center',
                time: 5000,
            })
        },
    },

}
</script>

<style scoped>
    .alert-gradient {
        background: linear-gradient(135deg, #9E4093 0%, #64355e 100%) !important;
    }

    .button-text {
        color: #eea6e7 !important;
        font-weight: 500;
        font-size: 8.5px;
    }
</style>